import { create } from "zustand";
import { persist } from "zustand/middleware";

interface InputStore {
  input: string;
  setInput: (input: string) => void;
  clearInput: () => void;
}

export const useInputStore = create<InputStore>()(
  persist(
    (set) => ({
      input: "",
      setInput: (input: string) => set({ input }),
      clearInput: () => set({ input: "" }),
    }),
    {
      name: "input-storage",
    }
  )
);
